// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"Graph_checkboxContainer__x28PL","plotContainer":"Graph_plotContainer__yl0Tv"};